import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ProgramsPage from "@/pages/ProgramsPage";
import SportPage from "@/pages/SportPage";
import SciencePage from "@/pages/SciencePage";
import InquirePage from "@/pages/InquirePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/sports/:slug" element={<SportPage />} />
            <Route path="/science" element={<SciencePage />} />
            <Route path="/inquire" element={<InquirePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
